import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { ContentModel, SectionModel } from '../models';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
  providedIn: 'root',
})
export class CourseContentService extends BaseFucntionsService<ContentModel> {
  routes = ApplicationRoutes.CourseContent;

  constructor(apiClient: ApiClientService) {
    super( ApplicationRoutes.CourseContent.CourseContents, apiClient);
  }

  objectToFormData(data: ContentModel) {
    const form_data = new FormData();

    Object.entries(data).forEach(item => {
      if (item[1]) {
        form_data.append(item[0], item[1]);
      }
    });

    return form_data;
  }

  get(id: number): any {
    return this.apiClient.get(this.routes.ContentDetails(id));
  }
  
  getCurrentSession() {
    return this.apiClient.get(`${ApplicationRoutes.CourseContent.CurrentSession}`);
  }
}
